export const schema = {
  type: 'object',
  properties: {
    icd10TMedicalCodes: {
      type: 'array',
      default: [],
      title: 'ICD10 Medical Codes',
      minItems: 1,
      items: {
        type: 'object',
        title: 'ICD10 Treatment Code',
        properties: {
          code: {
            type: 'string',
          },
          onsetDate: {
            type: 'string',
          },
        },
        required: ['code', 'onsetDate'],
      },
    },
    icd10TreatmentCodes: {
      type: 'array',
      default: [],
      title: 'ICD10 Treatment Codes',
      minItems: 1,
      items: {
        type: 'object',
        title: 'ICD10 Treatment Code',
        properties: {
          code: {
            type: 'string',
          },
          onsetDate: {
            type: 'string',
          },
        },
        required: ['code', 'onsetDate'],
      },
    },
  },
};
